// extracted by mini-css-extract-plugin
export default {"tip":"Censored_tip__11W9P"};